module.exports = __webpack_public_path__ + "static/media/Biosense_color.21c314f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/central_fert/Biosense_color.png
// module id = 2488
// module chunks = 3